import { DEFAULT_USER_FILTER } from 'constants/common'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  info: {},
  list: [],
  pagination: {},
  current: {},
  isoCode: 'eng',
  filter: DEFAULT_USER_FILTER
}

const user = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    case UserTypes.MY_PROFILE_SUCCESS:
      return { ...state, info: payload }
    case UserTypes.MY_PROFILE_FAILURE:
      return initialData
    case UserTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case UserTypes.GET_USER_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case UserTypes.GET_USER_DETAIL_FAILED:
      return { ...state, current: null }
    case UserTypes.UPDATE_DEFAULT_LANGUAGE:
      return { ...state, isoCode: payload }
    case UserTypes.UPDATE_FILTER_USER_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.CLEAR_FILTER_USER_SUCCESS:
      return { ...state, filter: initialData.filter }
    default:
      return state
  }
}

export default user
